export default __webpack_public_path__ + "f65ff4fd54363cd7e0a21f3e17880f24.jpg";